// Social and External link warning Fixed
document.addEventListener("DOMContentLoaded", function () {
  const currentHost = window.location.hostname.replace("www.", "");
  const warning = " Redirecting to a third-party website, opens in a new tab.";
  document.querySelectorAll("a[href]").forEach(function (link) {
    const href = link.href;
    if (!href.startsWith("http")) return;
    const linkHost = new URL(href).hostname.replace("www.", "");
    if (linkHost === currentHost) return;
    let label = link.getAttribute("aria-label") || link.textContent.trim();
    if (!label) {
      label = link.querySelector("img")?.alt || link.title || "External link";
    }
    if (!label.includes("Redirecting to a third-party website")) {
      label += warning;
    }
    link.setAttribute("aria-label", label);
    link.setAttribute("title", label);
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer nofollow");
  });
});
// add aria-hidden="true" on all br tags
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('br').forEach(function (br) {
    br.setAttribute('aria-hidden', 'true');
  });
});
//th broken aria-label issue fix "aria-labelled by removed
window.addEventListener('load', function () {
  document.querySelectorAll('[aria-labelledby]').forEach(function (el) {
    const refId = el.getAttribute('aria-labelledby');
    if (!document.getElementById(refId)) {
      el.removeAttribute('aria-labelledby');
    }
  });
});
// About us page accessibility 
document.addEventListener("DOMContentLoaded", function () {
  // Ensure "Our Story" heading is H1 on About Us page
  document.querySelectorAll('.block-heading_qx8agy, .text-overlay__title').forEach(function (heading) {
    if (heading.textContent.trim().toLowerCase().includes('our story') && heading.tagName.toLowerCase() === 'h2') {
      const h1 = document.createElement('h1');
      h1.innerHTML = heading.innerHTML;
      h1.className = heading.className;
      [...heading.attributes].forEach(attr => {
        if (attr.name !== 'class') {
          h1.setAttribute(attr.name, attr.value);
        }
      });
      heading.replaceWith(h1);
    }
  });

  // Change H3 to H2 + Fix Shop Now label
  document.querySelectorAll(".about-block").forEach(function (section) {
    let h3 = section.querySelector("h3");
    if (h3) {
      let h2 = document.createElement("h2");
      h2.innerHTML = h3.innerHTML;
      h2.className = h3.className;
      h3.replaceWith(h2);
    }
    let shopLink = section.querySelector('a');
    if (shopLink && shopLink.textContent.trim() === "Shop Now") {
      shopLink.setAttribute("aria-label", "Shop Now for flower collection");
      // Remove new tab behavior for same website link
      shopLink.removeAttribute("target");
      shopLink.removeAttribute("rel");
    }
  });

  // Ensure icon-boxs images have descriptive alt text and are not hidden
  document.querySelectorAll('.icon-boxs .box').forEach(function (box) {
    const img = box.querySelector('img');
    const title = box.querySelector('h3')?.textContent?.trim() || '';
    if (img) {
      img.removeAttribute('role');
      img.removeAttribute('aria-hidden');
      if (title && (!img.getAttribute('alt') || img.getAttribute('alt').trim() === '')) {
        img.setAttribute('alt', title);
      }
    }
  });

  // Ensure about us image has valid alt text
  document.querySelectorAll('img[src*="half_succulent"], .about-block .image-with-text__image img').forEach(function (img) {
    const alt = (img.getAttribute('alt') || '').trim();
    if (!alt) {
      const title = img.closest('.about-block')?.querySelector('h2, h3')?.textContent?.trim() || 'DIYers and Designers - We Got You Covered';
      img.setAttribute('alt', title);
    }
  });
});
// FAQS Page 
document.addEventListener("DOMContentLoaded", function () {
  // Change FAQ heading h3 to h1
  document.querySelectorAll(".collapsible-tabs__heading").forEach(function (heading) {
    if (heading.tagName.toLowerCase() === "h3") {
      const h1 = document.createElement("h1");
      h1.innerHTML = heading.innerHTML;
      h1.className = heading.className;
      h1.id = heading.id;
      heading.replaceWith(h1);
    }
  });
  // Accessible FAQ accordion
  document.querySelectorAll(".collapsible-tabs details").forEach(function (details) {
    const summary = details.querySelector("summary");
    if (!summary) return;
    summary.setAttribute("role", "button");
    summary.setAttribute("aria-expanded", details.open ? "true" : "false");
    details.addEventListener("toggle", function () {
      summary.setAttribute(
        "aria-expanded",
        details.open ? "true" : "false"
      );
    });
    // Close FAQ with Escape
    summary.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && details.open) {
        details.removeAttribute("open");
        summary.setAttribute(
          "aria-expanded",
          "false"
        );
        summary.focus();
      }
    });
  });
});
// aria label overall the web 
// document.addEventListener("DOMContentLoaded",function(){
// const generic=["shop now","learn more","view all","here","click here","read more","get started"];
// document.querySelectorAll("a").forEach(function(link){
// if(link.hasAttribute("aria-label"))return;
// const href=link.getAttribute("href")||"";
// const text=link.textContent.trim().replace(/\s+/g," ");
// if(href.startsWith("mailto:")){
// link.setAttribute("aria-label",`Email Flower Explosion at ${href.replace("mailto:","")}`);
// return;
// }
// if(href.startsWith("tel:")){
// link.setAttribute("aria-label",`Call Flower Explosion at ${href.replace("tel:","")}`);
// return;
// }
// if(!generic.includes(text.toLowerCase()))return;
// let name="";
// if(href.includes("/collections/")){
// name=href.split("/collections/")[1].split("?")[0];
// }else if(href.includes("/products/")){
// name=href.split("/products/")[1].split("?")[0];
// }else if(href.includes("/pages/")){
// name=href.split("/pages/")[1].split("?")[0];
// }
// if(name){
// name=name.replace(/-/g," ").replace(/\b\w/g,c=>c.toUpperCase());
// link.setAttribute("aria-label",`${text} ${name}`);
// }
// });
// });
document.addEventListener("DOMContentLoaded",function(){
const generic=["shop now","learn more","view all","here","click here","read more","get started"];

document.querySelectorAll("a").forEach(function(link){
const href=link.getAttribute("href")||"";
const text=link.textContent.trim().replace(/\s+/g," ");
const visibleText=text.toLowerCase();
const existingLabel=(link.getAttribute("aria-label")||"").trim();

if(href.startsWith("mailto:")){
const email=href.replace("mailto:","");
if(!existingLabel.toLowerCase().includes("email flower explosion")){
link.setAttribute("aria-label",`Email Flower Explosion at ${email}`);
}
return;
}

if(href.startsWith("tel:")){
const phone=href.replace("tel:","");
if(!existingLabel.toLowerCase().includes("call flower explosion")){
link.setAttribute("aria-label",`Call Flower Explosion at ${phone}`);
}
return;
}

if(!generic.includes(visibleText))return;

if(existingLabel && existingLabel.toLowerCase().includes(visibleText))return;

let name="";

if(href.includes("/collections/")){
name=href.split("/collections/")[1].split("?")[0];
}else if(href.includes("/products/")){
name=href.split("/products/")[1].split("?")[0];
}else if(href.includes("/pages/")){
name=href.split("/pages/")[1].split("?")[0];
}

if(name){
name=name.replace(/-/g," ").replace(/\b\w/g,c=>c.toUpperCase());

if(existingLabel){
link.setAttribute("aria-label",`${text} - ${existingLabel}`);
}else{
link.setAttribute("aria-label",`${text} ${name}`);
}
}
});
});
// 
document.addEventListener("DOMContentLoaded", function () {
  // Run only on the homepage
  if (window.location.pathname !== "/") {
    return;
  }

  var faqHeading = document.querySelector(
    '.section-collapsible-tabs .collapsible-tabs__heading'
  );

  if (faqHeading && faqHeading.tagName.toLowerCase() === "h1") {
    var h2 = document.createElement("h2");

    Array.from(faqHeading.attributes).forEach(function (attr) {
      h2.setAttribute(attr.name, attr.value);
    });

    h2.innerHTML = faqHeading.innerHTML;

    faqHeading.replaceWith(h2);
  }
});
// 
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll("details-disclosure details.disclosure").forEach(function (details) {

    const summary = details.querySelector("summary");

    if (!summary) return;

    // Make the summary behave like a button for screen readers
    summary.setAttribute("role", "button");

    // Set the initial state
    summary.setAttribute(
      "aria-expanded",
      details.open ? "true" : "false"
    );

    // Update aria-expanded whenever the native details state changes
    details.addEventListener("toggle", function () {

      summary.setAttribute(
        "aria-expanded",
        details.open ? "true" : "false"
      );

    });

    // Close the accordion with Escape
    summary.addEventListener("keydown", function (event) {

      if (event.key === "Escape" && details.open) {

        details.open = false;

        summary.setAttribute(
          "aria-expanded",
          "false"
        );

        summary.focus();
      }

    });

  });

});


// main menu  
// Main menu – accessible disclosure navigation (click-only, proper ARIA, Escape support)
(function () {
  function initAccessibleMenu() {
    const navigation = document.querySelector("#proxy-nav");
    if (!navigation) return;

    const mainNav = document.getElementById("main-nav");
    const items = Array.from(
      navigation.querySelectorAll(
        ".navigation__tier-1 > .navigation__item--with-children"
      )
    );

    const FOCUSABLE = "a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex='-1'])";

    const CHEVRON =
      '<svg class="nav-chevron" width="20" height="20" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true" focusable="false" role="presentation"><path d="M6 9l6 6 6-6"></path></svg>';

    function getLink(item) {
      return item.querySelector(".navigation__link");
    }

    function getPanel(item) {
      const link = getLink(item);
      const id = link && link.getAttribute("aria-controls");
      return id ? document.getElementById(id) : null;
    }

    function getMainItem(item) {
      if (!mainNav) return null;
      const itemIndex = Array.from(item.parentNode.children).indexOf(item);
      const mainItems = mainNav.querySelectorAll(".navigation__tier-1 > .navigation__item");
      return mainItems[itemIndex] || null;
    }

    function getFocusables(panel) {
      if (!panel) return [];
      return Array.from(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function setPanel(panel, show) {
      if (!panel) return;
      const styles = show
        ? { display: "block", visibility: "visible", opacity: "1", "pointer-events": "auto" }
        : { display: "none", visibility: "hidden", opacity: "0", "pointer-events": "none" };
      Object.keys(styles).forEach(function (prop) {
        panel.style.setProperty(prop, styles[prop], "important");
      });
      panel.setAttribute("aria-hidden", show ? "false" : "true");
    }

    function positionSmallMenu(item) {
      if (!item.classList.contains("navigation__item--with-small-menu")) return;
      const panel = getPanel(item);
      if (!panel) return;
      const isRtl = document.querySelector('html[dir="rtl"]');
      const itemRect = item.getBoundingClientRect();
      const panelWidth = panel.offsetWidth || 240;
      if (isRtl) {
        let right = window.innerWidth - itemRect.right;
        if (right + panelWidth > window.innerWidth) {
          right = Math.max(10, window.innerWidth - panelWidth - 10);
        }
        panel.style.right = `${right}px`;
        panel.style.left = "auto";
      } else {
        let left = itemRect.left;
        if (left + panelWidth > window.innerWidth) {
          left = Math.max(10, window.innerWidth - panelWidth - 10);
        }
        panel.style.left = `${left}px`;
        panel.style.right = "auto";
      }
    }

    function closeItem(item, returnFocus) {
      const link = getLink(item);
      const panel = getPanel(item);
      const mainItem = getMainItem(item);
      if (!link) return;

      link.setAttribute("aria-expanded", "false");
      item.classList.remove("is-open");
      if (panel) setPanel(panel, false);

      if (mainItem) {
        mainItem.classList.remove("navigation__item--show-children");
        const mainLink = mainItem.querySelector(".navigation__link");
        if (mainLink) mainLink.setAttribute("aria-expanded", "false");
      }

      const anyOpen = items.some(function (it) {
        const l = getLink(it);
        return l && l.getAttribute("aria-expanded") === "true";
      });
      if (!anyOpen) {
        const header = item.closest(".section-header");
        if (header) header.classList.remove("section-header--nav-open");
      }

      if (returnFocus) link.focus();
    }

    function openItem(item) {
      const link = getLink(item);
      const panel = getPanel(item);
      const mainItem = getMainItem(item);
      if (!link) return;

      // Close any other open items
      items.forEach(function (other) {
        if (other !== item) closeItem(other, false);
      });

      item.classList.add("is-open");
      link.setAttribute("aria-expanded", "true");

      if (panel) {
        setPanel(panel, true);
        positionSmallMenu(item);
      }

      if (mainItem) {
        mainItem.classList.add("navigation__item--show-children");
        const mainLink = mainItem.querySelector(".navigation__link");
        if (mainLink) mainLink.setAttribute("aria-expanded", "true");
      }

      const header = item.closest(".section-header");
      if (header) header.classList.add("section-header--nav-open");
    }

    function focusNextTopLevel(item) {
      const all = Array.from(
        navigation.querySelectorAll(".navigation__tier-1 > .navigation__item > .navigation__link")
      );
      const idx = all.indexOf(getLink(item));
      if (idx > -1 && all[idx + 1]) {
        all[idx + 1].focus();
        return true;
      }
      return false;
    }

    items.forEach(function (item) {
      const link = getLink(item);
      const panel = getPanel(item);
      if (!link) return;

      link.removeAttribute("href");
      link.removeAttribute("aria-haspopup");
      link.setAttribute("role", "button");
      link.setAttribute("tabindex", "0");
      link.setAttribute("aria-expanded", "false");

      if (!link.querySelector(".nav-chevron")) {
        link.insertAdjacentHTML("beforeend", CHEVRON);
      }

      if (panel) {
        item.setAttribute("aria-owns", panel.id);
        setPanel(panel, false);
      }

      // Click to toggle
      link.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const expanded = link.getAttribute("aria-expanded") === "true";
        expanded ? closeItem(item, false) : openItem(item);
      });

      // Keyboard on the trigger link
      link.addEventListener("keydown", function (e) {
        const expanded = link.getAttribute("aria-expanded") === "true";

        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.stopPropagation();
          expanded ? closeItem(item, false) : openItem(item);
        } else if (e.key === "Escape" && expanded) {
          e.preventDefault();
          e.stopPropagation();
          closeItem(item, true);
        } else if (e.key === "Tab" && !e.shiftKey && expanded && panel) {
          const focusables = getFocusables(panel);
          if (focusables.length > 0) {
            e.preventDefault();
            focusables[0].focus();
          }
        }
      });

      if (!panel) return;

      // Keyboard inside the panel
      panel.addEventListener("keydown", function (e) {
        const focusables = getFocusables(panel);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (e.key === "Escape") {
          e.preventDefault();
          e.stopPropagation();
          closeItem(item, true);
        } else if (e.key === "Tab") {
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            link.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            closeItem(item, false);
            if (focusNextTopLevel(item)) {
              e.preventDefault();
            }
          }
        }
      });
    });

    // Close when clicking outside the nav and any open panel
    document.addEventListener("click", function (e) {
      items.forEach(function (item) {
        const link = getLink(item);
        if (!link || link.getAttribute("aria-expanded") !== "true") return;

        const panel = getPanel(item);
        const inside = navigation.contains(e.target) || (panel && panel.contains(e.target));
        if (!inside) {
          closeItem(item, false);
        }
      });
    });

    // Close when focus moves outside the active trigger and its panel
    document.addEventListener("focusin", function (e) {
      items.forEach(function (item) {
        const link = getLink(item);
        if (!link || link.getAttribute("aria-expanded") !== "true") return;

        const panel = getPanel(item);
        const inside = item.contains(e.target) || (panel && panel.contains(e.target));
        if (!inside) {
          closeItem(item, false);
        }
      });
    });

    // Escape closes open dropdown from anywhere in the document
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;

      items.forEach(function (item) {
        const link = getLink(item);
        if (!link || link.getAttribute("aria-expanded") !== "true") return;

        const panel = getPanel(item);
        const focusInside =
          item.contains(document.activeElement) ||
          (panel && panel.contains(document.activeElement));

        closeItem(item, focusInside);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAccessibleMenu);
  } else {
    initAccessibleMenu();
  }
})();
//  h1 to h2 on homepge 
document.addEventListener("DOMContentLoaded", function () {
  const isHomepage = window.location.pathname === '/' || window.location.pathname === '' || document.body.classList.contains('template-index');
  if (!isHomepage) return;

  document.querySelectorAll("h1.text-overlay__title").forEach(function (heading) {
    const section = heading.closest(".shopify-section");

    if (!section) return;

    const h2 = document.createElement("h2");

    Array.from(heading.attributes).forEach(function (attr) {
      h2.setAttribute(attr.name, attr.value);
    });

    h2.innerHTML = heading.innerHTML;
    heading.replaceWith(h2);
  });
});

// Accessible Cart List Semantics & Integer Stepper Accessibility
(function () {
  function applyCartAccessibility() {
    // 1. List Semantics: "List 1", "List 2", etc.
    const listBodies = document.querySelectorAll('.cart-item-list__body, [data-merge-list="cart-items"]');
    listBodies.forEach(function (body) {
      const hasEmptyState = body.querySelector('[data-merge-list-item*="empty"], .fully-spaced-row--large, h1.majortitle') !== null;
      const items = Array.from(body.querySelectorAll('[data-merge-list-item]')).filter(function (item) {
        const itemKey = (item.getAttribute('data-merge-list-item') || '').trim();
        return itemKey && !itemKey.startsWith('item-key:head') && !itemKey.startsWith('item-key:empty');
      });

      const totalItems = items.length;

      // When cart is empty or shows empty state, it must NEVER have role="list" (WCAG 1.3.1 / ARIA 5.2.6)
      if (hasEmptyState || totalItems === 0) {
        body.removeAttribute('role');
        body.removeAttribute('aria-label');
        body.querySelectorAll('[data-merge-list-item*="empty"]').forEach(function (el) {
          el.removeAttribute('role');
          el.removeAttribute('aria-label');
        });
        return;
      }

      body.setAttribute('role', 'list');
      body.setAttribute('aria-label', 'Shopping Cart Items');

      // Table head row must be hidden from screen readers so it does not violate list child roles
      const headItem = body.querySelector('[data-merge-list-item^="item-key:head"]');
      if (headItem) {
        headItem.setAttribute('aria-hidden', 'true');
        headItem.removeAttribute('role');
      }

      items.forEach(function (item, index) {
        item.setAttribute('role', 'listitem');
        item.setAttribute('aria-posinset', String(index + 1));
        item.setAttribute('aria-setsize', String(totalItems));

        const titleLink = item.querySelector('.cart-item__title a');
        const title = titleLink ? titleLink.textContent.trim() : '';
        if (title) {
          item.setAttribute('aria-label', 'List ' + (index + 1) + ': ' + title);
        } else {
          item.setAttribute('aria-label', 'List ' + (index + 1));
        }

        // Ensure product image and image link are read by screen readers
        const img = item.querySelector('.cart-item__image img');
        if (img && (!img.getAttribute('alt') || img.getAttribute('alt').trim() === '')) {
          img.setAttribute('alt', title || 'Product image');
        }
        const imgLink = item.querySelector('.cart-item__image a');
        if (imgLink) {
          imgLink.removeAttribute('tabindex');
          imgLink.removeAttribute('aria-hidden');
          const imgAlt = (img && img.getAttribute('alt')) || title || 'Product';
          imgLink.setAttribute('aria-label', imgAlt + ' image');
        }
      });
    });

    // 2. Quantity Stepper: enforce integer step (1, 2...) and proper ARIA values
    document.querySelectorAll('.cart-item__quantity-input').forEach(function (input) {
      input.setAttribute('step', '1');
      input.setAttribute('min', '0');
      const val = parseInt(input.value, 10) || 1;
      input.setAttribute('aria-valuenow', String(val));
      input.setAttribute('aria-valuemin', '0');
      input.setAttribute('aria-valuetext', String(val));

      if (!input.dataset.stepAccessibility) {
        input.dataset.stepAccessibility = 'true';
        input.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault();
            let current = parseInt(input.value, 10) || 0;
            if (e.key === 'ArrowUp') {
              const max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : 999;
              if (current < max) current += 1;
            } else if (e.key === 'ArrowDown') {
              if (current > 0) current -= 1;
            }
            input.value = current;
            input.setAttribute('aria-valuenow', String(current));
            input.setAttribute('aria-valuetext', String(current));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        input.addEventListener('input', function () {
          const v = parseInt(input.value, 10) || 0;
          input.setAttribute('aria-valuenow', String(v));
          input.setAttribute('aria-valuetext', String(v));
        });
      }
    });

    document.querySelectorAll('.quantity-down').forEach(function (btn) {
      btn.setAttribute('role', 'button');
    });
    document.querySelectorAll('.quantity-up').forEach(function (btn) {
      btn.setAttribute('role', 'button');
    });

    // 3. Cart Price & Subtotal accessible labels & focus (read as flat text, not group)
    document.querySelectorAll('.cart-item__selling-price').forEach(function (priceEl) {
      priceEl.setAttribute('role', 'text');
      priceEl.setAttribute('tabindex', '0');
      let vh = priceEl.querySelector('.visually-hidden');
      if (!vh) {
        vh = document.createElement('span');
        vh.className = 'visually-hidden';
        vh.textContent = 'Regular price';
        priceEl.prepend(vh);
      }
      const rawText = priceEl.textContent.replace(/Regular price/g, '').trim();
      if (rawText) {
        priceEl.setAttribute('aria-label', 'Regular price ' + rawText);
      }
    });

    document.querySelectorAll('.cart-item__selling-total').forEach(function (totalEl) {
      totalEl.setAttribute('role', 'text');
      totalEl.setAttribute('tabindex', '0');
      let vh = totalEl.querySelector('.visually-hidden');
      if (!vh) {
        vh = document.createElement('span');
        vh.className = 'visually-hidden';
        vh.textContent = 'Total price';
        totalEl.prepend(vh);
      }
      const rawText = totalEl.textContent.replace(/Total price/g, '').trim();
      if (rawText) {
        totalEl.setAttribute('aria-label', 'Total price ' + rawText);
      }
    });

    document.querySelectorAll('.subtotal').forEach(function (subtotalEl) {
      subtotalEl.removeAttribute('aria-hidden');
      subtotalEl.removeAttribute('role');
      subtotalEl.removeAttribute('aria-label');
      const titleEl = subtotalEl.querySelector('.subtotal__title');
      if (titleEl) {
        titleEl.removeAttribute('aria-hidden');
        titleEl.setAttribute('tabindex', '0');
        titleEl.setAttribute('aria-label', 'Cart subtotal');
      }
      const moneyEl = subtotalEl.querySelector('.theme-money');
      if (moneyEl) {
        moneyEl.removeAttribute('aria-hidden');
        moneyEl.setAttribute('tabindex', '0');
        moneyEl.setAttribute('role', 'text');
        const amount = moneyEl.textContent.trim();
        if (amount) {
          moneyEl.setAttribute('aria-label', 'Cart subtotal price: ' + amount);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCartAccessibility);
  } else {
    applyCartAccessibility();
  }

  document.addEventListener('on:cart:change', function () {
    setTimeout(applyCartAccessibility, 50);
  });

  const cartObserver = new MutationObserver(function (mutations) {
    let shouldUpdate = false;
    for (let i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        shouldUpdate = true;
        break;

      }
    }
    if (shouldUpdate) applyCartAccessibility();
  });

  cartObserver.observe(document.body, { childList: true, subtree: true });
})();
// products label fixing
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("a.product-link").forEach(function (link) {
    const visibleText = link.textContent
      .trim()
      .replace(/\s+/g, " ");

    if (!visibleText) return;

    const ariaLabel = link.getAttribute("aria-label");

    if (!ariaLabel) return;

    if (ariaLabel.trim().toLowerCase() !== visibleText.toLowerCase()) {
      link.setAttribute("aria-label", visibleText);
    }
  });
});

// Product Card Accessibility: Active image announcement & descriptive image slider buttons
(function () {
  function enhanceProductCards() {
    document.querySelectorAll('.product-block').forEach(function (card) {
      // 1. Get product title for context
      const titleEl = card.querySelector('.product-block__title a, .product-block__title');
      const productTitle = titleEl ? titleEl.textContent.trim().replace(/\s+/g, ' ') : '';

      // 2. Image link: ensure it is read by screen reader (remove aria-hidden / tabindex=-1)
      const imageLink = card.querySelector('.image-cont > a.product-link, .image-cont a.product-link');
      if (imageLink) {
        if (imageLink.getAttribute('aria-hidden') === 'true') {
          imageLink.removeAttribute('aria-hidden');
        }
        if (imageLink.getAttribute('tabindex') === '-1' && !imageLink.hasAttribute('data-carousel-tabindex')) {
          imageLink.removeAttribute('tabindex');
        }
      }

      // 3. Ensure only active image is exposed to screen reader
      const images = card.querySelectorAll('.product-block__image');
      if (images.length > 0) {
        let hasActive = false;
        images.forEach(function (imgWrapper) {
          if (imgWrapper.classList.contains('product-block__image--active')) {
            hasActive = true;
            imgWrapper.removeAttribute('aria-hidden');
          } else {
            imgWrapper.setAttribute('aria-hidden', 'true');
          }
        });
        if (!hasActive && images[0]) {
          images[0].removeAttribute('aria-hidden');
        }
      }

      // 4. Product card image slider Previous & Next controls: hide from screen readers
      card.querySelectorAll('.image-page-button--previous, .image-page-button--next, .image-page-button').forEach(function (btn) {
        btn.setAttribute('aria-hidden', 'true');
        btn.setAttribute('tabindex', '-1');
        if (btn.hasAttribute('data-carousel-tabindex')) {
          btn.setAttribute('data-carousel-tabindex', '-1');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceProductCards);
  } else {
    enhanceProductCards();
  }

  let timer = null;
  const productObserver = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(enhanceProductCards, 80);
  });
  productObserver.observe(document.body, { childList: true, subtree: true });
})();

// Mobile Navigation Drawer Accessibility & Focus Trap
(function () {
  let previouslyFocusedElement = null;
  let lastTier1Toggle = null;
  let childObserverInitialized = false;

  function getDrawer() {
    return document.querySelector('.mobile-navigation-drawer');
  }

  function getTriggerButtons() {
    return document.querySelectorAll('.logo-area .mobile-nav-toggle, #pageheader .mobile-nav-toggle:not(.mobile-navigation-drawer .mobile-nav-toggle)');
  }

  function isElementVisible(el, container) {
    if (!el || el.disabled || el.getAttribute('aria-hidden') === 'true') return false;
    if (el.closest('[aria-hidden="true"]')) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    if (el.offsetParent === null && style.position !== 'fixed') return false;

    let parent = el.parentElement;
    while (parent && parent !== container) {
      if (parent.getAttribute('aria-hidden') === 'true') return false;
      const pStyle = window.getComputedStyle(parent);
      if (pStyle.display === 'none' || pStyle.visibility === 'hidden') return false;
      parent = parent.parentElement;
    }
    return true;
  }

  function getFocusableElements(container) {
    if (!container) return [];
    const selector = 'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])';
    const allCandidates = Array.from(container.querySelectorAll(selector));
    return allCandidates.filter(el => isElementVisible(el, container));
  }

  function updateChildOpenAccessibility(isChildOpen) {
    const drawer = getDrawer();
    if (!drawer) return;

    const backBtn = drawer.querySelector('.navigation__mobile-header .mobile-nav-back');
    const tier1Items = drawer.querySelectorAll('.navigation__tier-1 > .navigation__item');
    const mobProducts = drawer.querySelector('.navigation__mobile-products');
    const drawerFooter = drawer.querySelector('.mobile-navigation-drawer__footer');

    if (isChildOpen) {
      if (backBtn) {
        backBtn.removeAttribute('aria-hidden');
      }

      tier1Items.forEach(item => {
        if (item.classList.contains('navigation__item--open')) {
          const directLink = item.querySelector(':scope > .navigation__link');
          const directToggle = item.querySelector(':scope > .navigation__children-toggle');
          if (directLink) directLink.setAttribute('aria-hidden', 'true');
          if (directToggle) directToggle.setAttribute('aria-hidden', 'true');

          const tier2 = item.querySelector('.navigation__tier-2-container');
          if (tier2) tier2.setAttribute('aria-hidden', 'false');
        } else {
          item.setAttribute('aria-hidden', 'true');
        }
      });

      if (mobProducts) mobProducts.setAttribute('aria-hidden', 'true');
      if (drawerFooter) drawerFooter.setAttribute('aria-hidden', 'true');
    } else {
      if (backBtn) {
        backBtn.setAttribute('aria-hidden', 'true');
      }

      tier1Items.forEach(item => {
        item.removeAttribute('aria-hidden');
        const directLink = item.querySelector(':scope > .navigation__link');
        const directToggle = item.querySelector(':scope > .navigation__children-toggle');
        if (directLink) directLink.removeAttribute('aria-hidden');
        if (directToggle) directToggle.removeAttribute('aria-hidden');

        const tier2 = item.querySelector('.navigation__tier-2-container');
        if (tier2) tier2.setAttribute('aria-hidden', 'true');
      });

      if (mobProducts) mobProducts.removeAttribute('aria-hidden');
      if (drawerFooter) drawerFooter.removeAttribute('aria-hidden');
    }
  }

  function setupMobileDrawerAccessibility() {
    const drawer = getDrawer();
    if (!drawer) return;

    // Do NOT set role="dialog" or aria-modal="true" on drawer to prevent screen readers auto-reading all container contents on open
    drawer.removeAttribute('role');
    drawer.removeAttribute('aria-modal');
    drawer.removeAttribute('aria-label');

    getTriggerButtons().forEach(btn => {
      btn.removeAttribute('aria-haspopup');
      btn.setAttribute('aria-controls', drawer.id || 'mobile-navigation-drawer');
      if (!btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Open menu drawer');
    });

    const drawerCloseBtn = drawer.querySelector('.navigation__mobile-header .mobile-nav-toggle');
    if (drawerCloseBtn) {
      drawerCloseBtn.setAttribute('role', 'button');
      drawerCloseBtn.setAttribute('aria-label', 'Close');
    }

    const drawerBackBtn = drawer.querySelector('.navigation__mobile-header .mobile-nav-back');
    if (drawerBackBtn) {
      drawerBackBtn.setAttribute('role', 'button');
      if (!drawerBackBtn.getAttribute('aria-label') || drawerBackBtn.getAttribute('aria-label') === 'Back') {
        drawerBackBtn.setAttribute('aria-label', 'Back');
      }
    }

    drawer.querySelectorAll('.menu_colors .navigation__link').forEach(link => {
      if (!link.getAttribute('aria-label')) {
        const text = link.textContent.trim().replace(/\s+/g, ' ');
        if (text) link.setAttribute('aria-label', text);
      }
    });

    drawer.querySelectorAll('.navigation__tier-1 > .navigation__item > .navigation__children-toggle').forEach(toggle => {
      const parentLink = toggle.previousElementSibling;
      const title = parentLink ? parentLink.textContent.trim() : '';
      const isOpen = toggle.parentElement && toggle.parentElement.classList.contains('navigation__item--open');
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (title && (!toggle.getAttribute('aria-label') || toggle.getAttribute('aria-label') === 'Show links')) {
        toggle.setAttribute('aria-label', (isOpen ? 'Hide links – ' : 'Show links – ') + title);
      }
    });

    drawer.querySelectorAll('.navigation__tier-2 > .navigation__item > .navigation__children-toggle').forEach(toggle => {
      const parentTitleEl = toggle.previousElementSibling;
      const title = parentTitleEl ? parentTitleEl.textContent.trim() : '';
      const isOpen = toggle.parentElement && toggle.parentElement.classList.contains('navigation__item--open');
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (title && (!toggle.getAttribute('aria-label') || toggle.getAttribute('aria-label') === 'Show links')) {
        toggle.setAttribute('aria-label', (isOpen ? 'Hide links – ' : 'Show links – ') + title);
      }
    });

    updateChildOpenAccessibility(drawer.classList.contains('mobile-navigation-drawer--child-open'));

    // Observe drawer for child-open state changes
    if (!childObserverInitialized) {
      childObserverInitialized = true;
      const drawerChildObserver = new MutationObserver(function () {
        const isChildOpen = drawer.classList.contains('mobile-navigation-drawer--child-open');
        updateChildOpenAccessibility(isChildOpen);
      });
      drawerChildObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function onDrawerOpened() {
    const drawer = getDrawer();
    if (!drawer) return;

    getTriggerButtons().forEach(btn => btn.setAttribute('aria-expanded', 'true'));
    updateChildOpenAccessibility(false);

    // Isolate page content from screen reader
    const content = document.getElementById('content');
    if (content) content.setAttribute('aria-hidden', 'true');
    const pageHeader = document.getElementById('pageheader');
    if (pageHeader) pageHeader.setAttribute('aria-hidden', 'true');

    // Focus only the close button cleanly
    setTimeout(() => {
      const closeBtn = drawer.querySelector('.navigation__mobile-header .mobile-nav-toggle');
      if (closeBtn) {
        closeBtn.focus({ preventScroll: true });
      }
    }, 60);
  }

  function onDrawerClosed() {
    getTriggerButtons().forEach(btn => btn.setAttribute('aria-expanded', 'false'));

    // Restore page content to screen reader
    const content = document.getElementById('content');
    if (content) content.removeAttribute('aria-hidden');
    const pageHeader = document.getElementById('pageheader');
    if (pageHeader) pageHeader.removeAttribute('aria-hidden');

    if (previouslyFocusedElement && typeof previouslyFocusedElement.focus === 'function') {
      try {
        previouslyFocusedElement.focus({ preventScroll: true });
      } catch (e) {}
    } else {
      const trigger = document.querySelector('.logo-area .mobile-nav-toggle');
      if (trigger) trigger.focus({ preventScroll: true });
    }
  }

  let wasOpen = false;
  const bodyClassObserver = new MutationObserver(function () {
    const isOpen = document.body.classList.contains('reveal-mobile-nav');
    if (isOpen && !wasOpen) {
      wasOpen = true;
      previouslyFocusedElement = document.activeElement;
      setupMobileDrawerAccessibility();
      onDrawerOpened();
    } else if (!isOpen && wasOpen) {
      wasOpen = false;
      onDrawerClosed();
    }
  });

  bodyClassObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  document.addEventListener('keydown', function (e) {
    if (!document.body.classList.contains('reveal-mobile-nav')) return;
    const drawer = getDrawer();
    if (!drawer) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      document.body.classList.remove('reveal-mobile-nav', 'reveal-mobile-nav--revealed');
      setTimeout(() => {
        document.body.classList.remove('enable-mobile-nav-transition');
      }, 750);
      return;
    }

    if (e.key === 'Tab') {
      const focusable = getFocusableElements(drawer);
      if (focusable.length === 0) {
        e.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first || !drawer.contains(document.activeElement)) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last || !drawer.contains(document.activeElement)) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  });

  document.addEventListener('click', function (e) {
    const drawer = getDrawer();
    if (!drawer || !drawer.contains(e.target)) return;

    const tier1Toggle = e.target.closest('.navigation__tier-1 > .navigation__item > .navigation__children-toggle');
    if (tier1Toggle) {
      lastTier1Toggle = tier1Toggle;
      const title = (tier1Toggle.previousElementSibling ? tier1Toggle.previousElementSibling.textContent.trim() : '');
      tier1Toggle.setAttribute('aria-expanded', 'true');
      if (title) tier1Toggle.setAttribute('aria-label', 'Hide links – ' + title);

      setTimeout(() => {
        updateChildOpenAccessibility(true);
        const backBtn = drawer.querySelector('.mobile-nav-back');
        if (backBtn && isElementVisible(backBtn, drawer)) {
          backBtn.focus({ preventScroll: true });
        }
      }, 80);
      return;
    }

    const backBtn = e.target.closest('.mobile-nav-back');
    if (backBtn) {
      setTimeout(() => {
        updateChildOpenAccessibility(false);
        if (lastTier1Toggle) {
          const title = (lastTier1Toggle.previousElementSibling ? lastTier1Toggle.previousElementSibling.textContent.trim() : '');
          lastTier1Toggle.setAttribute('aria-expanded', 'false');
          if (title) lastTier1Toggle.setAttribute('aria-label', 'Show links – ' + title);
          try {
            lastTier1Toggle.focus({ preventScroll: true });
          } catch (err) {}
        }
      }, 80);
      return;
    }

    const tier2Toggle = e.target.closest('.navigation__tier-2 > .navigation__item > .navigation__children-toggle');
    if (tier2Toggle) {
      setTimeout(() => {
        const isOpen = tier2Toggle.parentElement && tier2Toggle.parentElement.classList.contains('navigation__item--open');
        const titleEl = tier2Toggle.previousElementSibling;
        const title = titleEl ? titleEl.textContent.trim() : '';
        tier2Toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (title) {
          tier2Toggle.setAttribute('aria-label', (isOpen ? 'Hide links – ' : 'Show links – ') + title);
        }
      }, 20);
      return;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMobileDrawerAccessibility);
  } else {
    setupMobileDrawerAccessibility();
  }
})();

// PDP Product Gallery accessibility enhancements
(function () {
  function fixGalleryA11y() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (!gallery.getAttribute('role')) {
        gallery.setAttribute('role', 'region');
      }
      if (!gallery.getAttribute('aria-label')) {
        gallery.setAttribute('aria-label', 'Product media gallery');
      }

      // Main image carousel-slider
      const mainCarousel = gallery.querySelector('.main-image carousel-slider');
      if (mainCarousel) {
        if (!mainCarousel.getAttribute('role')) {
          mainCarousel.setAttribute('role', 'region');
        }
        if (!mainCarousel.getAttribute('aria-roledescription')) {
          mainCarousel.setAttribute('aria-roledescription', 'Carousel');
        }
        const currentLabel = mainCarousel.getAttribute('aria-label');
        if (!currentLabel || currentLabel.trim() === '') {
          const productTitle = document.querySelector('.product-title, h1.product-title, .product-area__title, h1')?.textContent?.trim() || 'Product';
          mainCarousel.setAttribute('aria-label', productTitle + ' images');
        }
      }

      // Thumbnails carousel-slider
      const thumbCarousel = gallery.querySelector('carousel-slider.thumbnails');
      if (thumbCarousel) {
        if (!thumbCarousel.getAttribute('role')) {
          thumbCarousel.setAttribute('role', 'region');
        }
        if (!thumbCarousel.getAttribute('aria-roledescription')) {
          thumbCarousel.setAttribute('aria-roledescription', 'Carousel');
        }
        const thumbLabel = thumbCarousel.getAttribute('aria-label');
        if (!thumbLabel || thumbLabel.trim() === '') {
          thumbCarousel.setAttribute('aria-label', 'Product thumbnails');
        }
      }

      // Thumbnail links
      const thumbLinks = gallery.querySelectorAll('.thumbnails .thumbnail');
      const totalThumbs = thumbLinks.length;
      thumbLinks.forEach(function (thumb, index) {
        const item = thumb.closest('.slider__item');
        const isActive = item ? item.classList.contains('is-active') : false;
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }

        const currentAria = thumb.getAttribute('aria-label');
        if (!currentAria || currentAria.trim() === '') {
          const img = thumb.querySelector('img');
          const altText = (img && img.getAttribute('alt')) ? img.getAttribute('alt').trim() : '';
          const productTitle = document.querySelector('.product-title, h1.product-title, .product-area__title, h1')?.textContent?.trim() || 'Product';
          const name = altText || productTitle;
          const label = 'Thumbnail ' + (index + 1) + ' of ' + totalThumbs + (name ? ' – ' + name : '');
          thumb.setAttribute('aria-label', label);

          if (!thumb.querySelector('.visually-hidden')) {
            const vh = document.createElement('span');
            vh.className = 'visually-hidden';
            vh.textContent = label;
            thumb.appendChild(vh);
          }
        }
      });
    });

    // Gallery viewer modal thumbs
    document.querySelectorAll('.gallery-viewer__thumb').forEach(function (thumb, index, all) {
      if (!thumb.getAttribute('aria-label')) {
        const img = thumb.querySelector('img');
        const altText = (img && img.getAttribute('alt')) ? img.getAttribute('alt').trim() : '';
        const productTitle = document.querySelector('.product-title, h1.product-title, .product-area__title, h1')?.textContent?.trim() || 'Product';
        const name = altText || productTitle;
        const label = 'Thumbnail ' + (index + 1) + ' of ' + all.length + (name ? ' – ' + name : '');
        thumb.setAttribute('aria-label', label);

        if (!thumb.querySelector('.visually-hidden')) {
          const vh = document.createElement('span');
          vh.className = 'visually-hidden';
          vh.textContent = label;
          thumb.appendChild(vh);
        }
      }
    });

    // Slider prev/next navigation buttons
    document.querySelectorAll('button[name="prev"], button[name="next"]').forEach(function (btn) {
      const isPrev = btn.getAttribute('name') === 'prev';
      const defaultText = isPrev ? 'Previous slide' : 'Next slide';
      const currentAria = (btn.getAttribute('aria-label') || '').trim();
      const vhSpan = btn.querySelector('.visually-hidden');
      const vhText = vhSpan ? vhSpan.textContent.trim() : '';

      if (!currentAria || currentAria.toLowerCase() === 'previous' || currentAria.toLowerCase() === 'next') {
        btn.setAttribute('aria-label', defaultText);
      }
      if (vhSpan && (vhText.toLowerCase() === 'previous' || vhText.toLowerCase() === 'next')) {
        vhSpan.textContent = defaultText;
      }
    });
  }

  function updateActiveThumbnail() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      gallery.querySelectorAll('.thumbnails .thumbnail').forEach(function (thumb) {
        const item = thumb.closest('.slider__item');
        if (item && item.classList.contains('is-active')) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixGalleryA11y);
  } else {
    fixGalleryA11y();
  }

  window.addEventListener('load', fixGalleryA11y);
  document.addEventListener('on:media-gallery:change', function () {
    fixGalleryA11y();
    updateActiveThumbnail();
  });
  document.addEventListener('on:carousel-slider:select', function () {
    updateActiveThumbnail();
  });
  document.addEventListener('on:variant:change', function () {
    setTimeout(function () {
      fixGalleryA11y();
      updateActiveThumbnail();
    }, 100);
  });
})();

// Contact form required field indicators
(function () {
  function addRequiredFieldIndicators() {
    document.querySelectorAll('form.contact-form, form[action*="/contact"]').forEach(function (form) {
      form.querySelectorAll('input[required], textarea[required], select[required]').forEach(function (input) {
        let label = null;
        if (input.id) {
          label = form.querySelector('label[for="' + input.id + '"]');
        }
        if (!label) {
          label = input.closest('label') || input.parentElement?.querySelector('label');
        }
        if (label && !label.textContent.includes('*')) {
          const star = document.createElement('span');
          star.className = 'required';
          star.setAttribute('aria-hidden', 'true');
          star.textContent = ' *';
          label.appendChild(star);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addRequiredFieldIndicators);
  } else {
    addRequiredFieldIndicators();
  }
})();

// Pagination accessibility enhancement
(function () {
  function fixSliderNavA11y() {
    // Generic elements (div) cannot have aria-label per ARIA 5.2.8.6
    document.querySelectorAll('.collection-slider-nav[aria-label], .slider-nav:not([role])[aria-label]').forEach(function (sliderNav) {
      sliderNav.removeAttribute('aria-label');
    });
  }

  function fixPaginationA11y() {
    document.querySelectorAll('.pagination').forEach(function (pagination) {
      if (!pagination.getAttribute('role')) {
        pagination.setAttribute('role', 'navigation');
      }
      if (!pagination.getAttribute('aria-label')) {
        pagination.setAttribute('aria-label', 'Pagination');
      }

      // Ensure active/current page item has aria-current="page"
      pagination.querySelectorAll('.pagination__number, .pagination__item').forEach(function (el) {
        const text = el.textContent.trim().replace(/^Page\s*/i, '');
        const isCurrent = el.classList.contains('underline--not-link') ||
                          el.classList.contains('active') ||
                          el.classList.contains('current') ||
                          el.classList.contains('pagination__item--current') ||
                          (!el.querySelector('a') && /^\d+$/.test(text));

        // Generic elements (like span) cannot have aria-label per ARIA 5.2.8.6
        el.removeAttribute('aria-label');

        if (isCurrent && /^\d+$/.test(text)) {
          if (!el.hasAttribute('aria-current')) {
            el.setAttribute('aria-current', 'page');
          }
        } else if (text === '…' || text === '...') {
          el.setAttribute('aria-hidden', 'true');
        }
      });

      // Ensure page links have accessible labels
      pagination.querySelectorAll('a').forEach(function (link) {
        const text = link.textContent.trim().replace(/^Page\s*/i, '');
        const currentLabel = link.getAttribute('aria-label');

        if (/^\d+$/.test(text)) {
          if (!currentLabel || currentLabel === text) {
            link.setAttribute('aria-label', 'Page ' + text);
          }
        } else if (text.toLowerCase().includes('next') || text.includes('»')) {
          if (!currentLabel) {
            link.setAttribute('aria-label', 'Next page');
          }
        } else if (text.toLowerCase().includes('previous') || text.toLowerCase().includes('prev') || text.includes('«')) {
          if (!currentLabel) {
            link.setAttribute('aria-label', 'Previous page');
          }
        }
      });

      // Hide decorative separators
      pagination.querySelectorAll('.pagination__sep').forEach(function (sep) {
        sep.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function normalizeProductLinks() {
    // WCAG F63 / 2.4.4: Ensure links with identical product names always point to canonical /products/ URLs
    document.querySelectorAll('.product-block a[href*="/collections/"][href*="/products/"]').forEach(function (link) {
      const href = link.getAttribute('href');
      if (href) {
        const productIndex = href.indexOf('/products/');
        if (productIndex !== -1) {
          link.setAttribute('href', href.slice(productIndex));
        }
      }
    });
  }

  function fixViewAllLinks() {
    // WCAG 2.4.4 / 2.4.9: Ensure generic "View all" links have descriptive context
    document.querySelectorAll('.view-all a').forEach(function (link) {
      const text = link.textContent.trim().toLowerCase();
      if ((text === 'view all' || text.startsWith('view all')) && !link.getAttribute('aria-label')) {
        const section = link.closest('.section-id, [class*="section-id-"], section');
        const heading = section ? section.querySelector('h2, .has-paging__title') : null;
        if (heading) {
          const headingText = heading.textContent.trim();
          if (headingText) {
            link.setAttribute('aria-label', link.textContent.trim() + ' \u2013 ' + headingText);
          }
        }
      }
    });
  }

  function applyPaginationAndSliderFixes() {
    fixPaginationA11y();
    fixSliderNavA11y();
    normalizeProductLinks();
    fixViewAllLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPaginationAndSliderFixes);
  } else {
    applyPaginationAndSliderFixes();
  }
  window.addEventListener('load', applyPaginationAndSliderFixes);
  document.addEventListener('theme:filter:loaded', applyPaginationAndSliderFixes);

  const observer = new MutationObserver(function (mutations) {
    for (let i = 0; i < mutations.length; i++) {
      const added = mutations[i].addedNodes;
      for (let j = 0; j < added.length; j++) {
        const node = added[j];
        if (node.nodeType === 1 && (node.matches?.('.pagination, .pagination-row, .slider-nav, .collection-slider-nav, .product-block, .view-all') || node.querySelector?.('.pagination, .pagination-row, .slider-nav, .collection-slider-nav, .product-block, .view-all'))) {
          applyPaginationAndSliderFixes();
          return;
        }
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();

// Add to cart button & cart drawer accessibility
(function () {
  let lastAddToCartButton = null;

  function ensureAddToCartA11y() {
    const atcButtons = document.querySelectorAll(
      'button[name="add"], .add-to-cart[type="submit"], button.add-to-cart, form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]'
    );
    atcButtons.forEach(function (button) {
      if (!button.getAttribute('aria-haspopup')) {
        button.setAttribute('aria-haspopup', 'dialog');
      }
    });
  }

  // Track the add to cart button that was activated
  document.addEventListener('click', function (evt) {
    const btn = evt.target.closest('button[name="add"], .add-to-cart, form[action*="/cart/add"] button[type="submit"]');
    if (btn) {
      lastAddToCartButton = btn;
    }
  }, true);

  document.addEventListener('submit', function (evt) {
    const form = evt.target.closest('form[action*="/cart/add"]');
    if (form) {
      const btn = form.querySelector('button[name="add"], button[type="submit"], .add-to-cart');
      if (btn) {
        lastAddToCartButton = btn;
      }
    }
  }, true);

  // Shift focus into cart drawer when opened
  function shiftFocusToDrawer(drawer) {
    if (!drawer || !drawer.hasAttribute('open')) return;

    if (lastAddToCartButton && !drawer.opener) {
      drawer.opener = lastAddToCartButton;
    }

    const doFocus = function () {
      if (!drawer.hasAttribute('open')) return;
      // If focus is already inside drawer (and not on container itself), do nothing
      if (drawer.contains(document.activeElement) && document.activeElement !== drawer) {
        return;
      }
      const closeBtn = drawer.querySelector(
        '.cart-drawer__content:not(.cart-drawer__content--hidden) .drawer__close-btn, .drawer__close-btn:not([hidden]), .js-close-drawer'
      );
      const focusTarget = closeBtn || drawer.querySelector('button:not([disabled]), a[href], input:not([disabled])') || drawer;
      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus({ preventScroll: true });
      }
    };

    doFocus();
    requestAnimationFrame(doFocus);
    setTimeout(doFocus, 50);
    setTimeout(doFocus, 150);
    setTimeout(doFocus, 350);
  }

  document.addEventListener('on:cart-drawer:before-open', function (evt) {
    shiftFocusToDrawer(evt.target);
  });
  document.addEventListener('on:cart-drawer:after-open', function (evt) {
    shiftFocusToDrawer(evt.target);
  });
  document.addEventListener('on:cart:after-merge', function () {
    const drawer = document.querySelector('.js-cart-drawer[open]');
    if (drawer) {
      shiftFocusToDrawer(drawer);
    }
  });

  function observeCartDrawer() {
    const drawer = document.querySelector('.js-cart-drawer, cart-drawer');
    if (drawer) {
      const drawerObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (drawer.hasAttribute('open')) {
              shiftFocusToDrawer(drawer);
            } else if (lastAddToCartButton) {
              if (!document.activeElement || document.activeElement === document.body) {
                lastAddToCartButton.focus();
              }
            }
          }
        });
      });
      drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['open', 'aria-hidden'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureAddToCartA11y();
      observeCartDrawer();
    });
  } else {
    ensureAddToCartA11y();
    observeCartDrawer();
  }

  window.addEventListener('load', ensureAddToCartA11y);
  document.addEventListener('on:variant:change', ensureAddToCartA11y);
})();